import React, {useState, useEffect, Fragment} from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {getclosedinvoices} from '../../actions/getserviceinvoicesActions';
import NoItems from '../NoItems';
import Pagination from "react-js-pagination";
import Spin from "../Spin";
import ConnectionLost from "../ConnectionLost";
import { I18n } from 'react-redux-i18n';
import { TitleComponent } from "../../components/TitleComponent";
import { MetaComponent } from "../../components/MetaComponent";


export default function AwaitingServices() {
    const dispatch = useDispatch();

    const { 
        userLoading,
        closedinvoices,
        closedtotalRecords,
        closeditemsPerPage,
        loadingclosedinvoices,
        errorId,
        errorMessage,
    } = useSelector((state) => ({
        userLoading: state.auth.isLoading,
        closedinvoices: state.serviceInvoices.closedinvoices,
        closedtotalRecords: state.serviceInvoices.closedtotalRecords,
        closeditemsPerPage: state.serviceInvoices.closeditemsPerPage,
        loadingclosedinvoices: state.serviceInvoices.loadingclosedinvoices,
        errorId: state.error.id,
        errorMessage: state.error.msg,
    }));

    const [activePage, setActivePage] = useState(1);
    const [loadingServices, setLoadingServices] = useState(true);

    useEffect(() => {
        setLoadingServices(loadingclosedinvoices);
    }, [loadingclosedinvoices]);

    useEffect(() => {
        const page = activePage;
        const limit = 12;
        const statusId = 4; 
        dispatch(getclosedinvoices(null, null, statusId, page, limit, null, null));
    }, [dispatch, activePage]);

    const handlePageChange = (pageNumber) =>{
        setActivePage(pageNumber);
    }
    //invoices = invoices.filter( ({status: {id}}) => id == 6 );
    //Get Services
    const totalItemsCount = closedtotalRecords;
    const itemsCountPerPage = Number(closeditemsPerPage);
    return(
        <div className="Offers__List">
            <TitleComponent title={I18n.t("lancersin_services_Awaiting")} />
            <MetaComponent />
            <div className="row">
                {
                    loadingServices || userLoading ?
                    <Spin />
                    : errorId === "GET_CLOSED_INVOICES_FAIL" && errorMessage === "Network Error" ?
                    <div className="col-12">
                        <ConnectionLost
                            errorType= "connection"
                            title = "network_error_title"
                            message = "network_error_message"
                        />
                    </div>
                    : errorId === "GET_CLOSED_INVOICES_FAIL" ?
                    <div className="col-12">
                        <ConnectionLost
                            errorType= "somethingWrong"
                            title = "something_error_title"
                            message = "something_error_message"
                        />
                    </div>
                    :
                    closedinvoices.length > 0 && !loadingServices ?
                    <Fragment>
                        <div className='col-12'>
                            <div className="alert alert-warning mb-4" role="alert">
                                {I18n.t('awaiting_payment_message')}
                            </div>
                        </div>
                        {
                            closedinvoices.map( item => (
                                <div className="col-md-6 col-lg-4" key={item.id}>
                                    <div className="services__listitem box-shadow">
                                        <figure>
                                            <Link className="services__imgcontainer" to={{pathname:`/services/invoices/${item.id}/${item.service.title.replace(/\s+/g, '-').replace(/\//g, '-').toLowerCase()}`}}>
                                                <img src={item.service.image.url ? item.service.image.url : item.service.image} alt={item.service.title} />
                                            </Link>
                                            <figcaption>
                                                <div className="Service__Provider">
                                                    <div className="img-container">
                                                        <img src={item.service.user.image.url ? item.service.user.image.url : item.service.user.image} alt={item.service.user.fname + ' ' + item.service.user.lname} className="img-fluid" />
                                                    </div>
                                                    <p>
                                                        <Link to={{pathname:`/in/${item.service.user.username}`}}>{item.service.user.fname} {item.service.user.lname}</Link>
                                                    </p>
                                                </div>
                                                <h2><Link to={{pathname:`/services/invoices/${item.id}/${item.service.title.replace(/\s+/g, '-').replace(/\//g, '-').toLowerCase()}`}}>{item.service.title}</Link></h2>
                                            </figcaption>
                                        </figure>
                                        <div className="services__info">
                                            <div className="bought">
                                                <span className="icon icon-deal"></span>{item.qty}
                                            </div>
                                            <div className="price">
                                            <span className="icon icon-price-label"></span>{item.due}$
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                        <div className="col-12 my-4">
                            <Pagination
                                activePage={activePage}
                                itemsCountPerPage={itemsCountPerPage}
                                totalItemsCount={totalItemsCount}
                                pageRangeDisplayed={10}
                                onChange={handlePageChange}
                                itemClass="page-item"
                                linkClass="page-link"
                            />
                        </div>
                    </Fragment>
                    :
                    <div className="col-12">
                        <NoItems />
                    </div>                  
                }
            </div>
        </div>
    )
}
